// --------------------------------------------------------------
// Created On: 2024-04-03
// Author: Hannah Vaughan
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./LogoLink.module.scss";

// Component containing a customizable logo and a button below with a customizable link and text.
export default function LogoLink(props: Props): Component {
  return (
    <a className={styles.body} href={props.buttonUrl} target="_blank" rel="noreferrer" data-test="logo-link">
      <img src={props.logoUrl} className={`${styles.logoImage} mt-2`} data-test="logo-link-image" />
      <br />
      <button className={`${styles.logoButton} btn btn-primary mb-2`} data-test="logo-link-button">
        {props.buttonDescription}
      </button>
    </a>
  );
}

interface Props {
  logoUrl: string;
  buttonUrl: string;
  buttonDescription: string;
}
